const FuseOptions = {
  includeScore: true,
  keys: ["fileName", "cellName"],
};

export default FuseOptions;
